export default function clearBrowserData() {
  try {
    // localStorage
    localStorage.clear();

    // sessionStorage
    sessionStorage.clear();

    // cookies
    document.cookie.split(';').forEach((cookie) => {
      const name = cookie.split('=')[0].trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });

    // chache
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }

    window.location.reload(true);

    return;
  } catch (error) {
    console.error('Cleaning error', error);
    return;
  }
}
